const leo = typeof window !== 'undefined' && window?.leo ? window.leo : null;
export default leo;
